"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [];



//////////////////
// WEBPACK FOOTER
// ./dist/app-importer.generated.js
// module id = 2132
// module chunks = 0